import React from 'react';
import { Button, createMuiTheme, ThemeProvider } from '@material-ui/core';

interface IColorButton {
  color: string;
  darkColor?: string;
  onClick?: () => {} | void;
  title?: string;
}

const ColorButton: React.FC<IColorButton> = ({ children, color, onClick, title }) => {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: color,
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Button onClick={onClick} color="primary" variant="contained" disableElevation>
        {children}
      </Button>
    </ThemeProvider>
  );
};

export default ColorButton;
